import BankRepository from "../repository/bank-repository";

class BankService
{
    #bankRepository;

    constructor() {
        this.#bankRepository = new BankRepository();
    }

    async findAll() {
        try {
            const data = await this.#bankRepository.getAll();

            return data;
        } catch (error) {
            console.error(error);
        }
    }
}
export default BankService;